var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 28H33.3333C30.4 28 28 30.4 28 33.3333V46.6667C28 49.6 30.4 52 33.3333 52H46.6667C49.6 52 52 49.6 52 46.6667V33.3333C52 30.4 49.6 28 46.6667 28ZM44.72 48C44.28 48 43.8533 47.7733 43.6133 47.4L39.3067 40.96L37.3333 43.4667V46.6667C37.3333 47.4 36.9333 48 36.44 48H35.56C35.0667 48 34.6667 47.4 34.6667 46.6667V33.3333C34.6667 32.6 35.0667 32 35.56 32H36.44C36.9333 32 37.3333 32.6 37.3333 33.3333V38.44L42.2667 32.48C42.5173 32.176 42.8907 32 43.2853 32H43.6707C44.788 31.9987 45.412 33.2907 44.7147 34.1653L41.24 38.52L46.1853 45.9267C46.7773 46.812 46.1427 48 45.0773 48H44.72Z",
    fill: "#D00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeras);
export default __webpack_public_path__ + "static/media/keras.e62f0268f53f06d58b2e25a81d9e2c22.svg";
export { ForwardRef as ReactComponent };